// generated by genversion
export const version = '1.1.3';
//# sourceMappingURL=version.js.map